(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/constants.js');

const FORMS = {
  HEADER: 'Glömt lösenord',
  RESTORE_OPTION_HEADER: 'Hur vill du få ditt lösenord?',
  RESTORE_OPTIONS: {
    SMS: {
      value: 'TextMessage',
      label: 'Skicka via sms',
      text: 'SMS'
    },
    LETTER: {
      value: 'Letter',
      label: 'Skicka via brev',
      text: 'brev'
    }
  },
  EMAIL: {
    EMAIL_LABEL: 'Användarnamn (e-postadress)',
    EMAIL_MAX: 100,
    EMAIL_REQUIRED_ERROR: 'Du måste ange en e-postadress',
    EMAIL_NAME: 'email'
  },
  MOBILE: {
    MOBILE_LABEL: 'Ange registrerat mobilnummer',
    MOBILE_NAME: 'mobil'
  }
};
svs.ticket_partner.passwordRecovery.constants = {
  FORMS
};


 })(window);